import { toast } from "sonner";

export const confirmToast = ({
  title,
  description,
  confirmLabel = "Confirmar",
  cancelLabel = "Cancelar",
  onConfirm,
  variant = "warning",
}) => {
  const isDanger = variant === "danger";
  const id = toast(title, {
    description,
    duration: Infinity,
    action: {
      label: confirmLabel,
      onClick: () => {
        toast.dismiss(id);
        onConfirm?.();
      },
    },
    cancel: {
      label: cancelLabel,
      onClick: () => toast.dismiss(id),
    },
    classNames: {
      toast: isDanger ? "border-red-200" : "border-slate-200",
      actionButton: isDanger
        ? "!bg-red-600 !text-white hover:!bg-red-700"
        : "!bg-primary !text-white hover:!bg-primary/90",
      cancelButton:
        "!bg-white !text-slate-700 !border !border-slate-200 hover:!bg-slate-50",
    },
    actionButtonStyle: {
      backgroundColor: isDanger ? "#dc2626" : "#2563eb",
      color: "#ffffff",
      border: "1px solid transparent",
    },
    cancelButtonStyle: {
      backgroundColor: "#ffffff",
      color: "#334155",
      border: "1px solid #cbd5e1",
    },
  });
};
